// import { MainError } from "../models/main-error";
// import { authSlice } from "../redux/reducers/authSlice";

// import { ConnectErrorModel } from "../models/ConnectErrorModel";
// import { ErrorModel } from "../models/ErrorModel";
// import { LanguageModel } from "../models/LanguageModel";
// import { UserModel } from "../models/UserModel";

export class Helpers {
    static isEmpty(text: any) {
        try {
            if (text == undefined)
                return true;

            if (text == null)
                return true;

            if (text.trim() == '')
                return true;

            return false;
        } catch (error) {
            return false;
        }
    }

    static toNumber(_str: string | undefined) {
        try {
            if (!_str || this.isEmpty(_str))
                return 0;

            _str = _str.toString().replace(",", ".").trim();

            if (_str.toString().endsWith("."))
                _str = _str.toString().replace(".", "").trim();

            return parseFloat(_str.toString());
        } catch (error) {
            return -1;
        }
    }

    static validateVkn(_kno: string | undefined) {
        if (!_kno)
            return false;

        var kno = _kno;

        if (kno.length === 10) {
            let v = []
            let lastDigit = Number(kno.charAt(9))
            for (let i = 0; i < 9; i++) {
                let tmp = (Number(kno.charAt(i)) + (9 - i)) % 10
                v[i] = (tmp * 2 ** (9 - i)) % 9
                if (tmp !== 0 && v[i] === 0) v[i] = 9
            }
            let sum = v.reduce((a, b) => a + b, 0) % 10
            return (10 - (sum % 10)) % 10 === lastDigit
        }
        return false
    }

    static validateTckn(_tcno: string | undefined) {
        if (!_tcno)
            return false;
        // geleni her zaman String'e çevirelim!
        var tcno = String(_tcno);

        // tcno '0' karakteri ile başlayamaz!
        if (tcno.substring(0, 1) === '0') {
            return false;
        }
        // Tcno 11 karakter uzunluğunda olmalı!
        if (tcno.length !== 11) {
            return false;
        }

        /**
            Aşağıdaki iki kontrol için toplamları hazır ediyoruz
            - o anki karakteri sayıya dönüştür
            - tek haneleri ayrıca topla (1,3,5,7,9)
            - çift haneleri ayrıca topla (2,4,6,8)
            - bütün haneleri ayrıca topla
        **/
        var ilkon_array = tcno.substr(0, 10).split('');
        var ilkon_total = 0;
        var hane_tek = 0;
        var hane_cift = 0;
        var j = 0;

        for (var i = 0; i < 9; ++i) {
            j = parseInt(ilkon_array[i], 10);
            if (i & 1) { // tek ise, tcnin çift haneleri toplanmalı!
                hane_cift += j;
            } else {
                hane_tek += j;
            }
            ilkon_total += j;
        }

        /**
            KONTROL 1:
            1. 3. 5. 7. ve 9. hanelerin toplamının 7 katından, 
            2. 4. 6. ve 8. hanelerin toplamı çıkartıldığında, 
            elde edilen sonucun Mod10'u bize 10. haneyi verir
        **/
        if ((hane_tek * 7 - hane_cift) % 10 !== parseInt(tcno.substr(-2, 1), 10)) {
            return false;
        }

        /**
            KONTROL 2:
            1. 2. 3. 4. 5. 6. 7. 8. 9. ve 10. hanelerin toplamından
            elde edilen sonucun Mod10'u bize 11. haneyi vermelidir.
            NOT: ilk 9 haneyi üstteki FOR döndüsünde zaten topladık!
        **/
        ilkon_total += parseInt(ilkon_array[9], 10);
        if (ilkon_total % 10 !== parseInt(tcno.substr(-1), 10)) {
            return false;
        }

        return true;
    }

    static generateUUID(_isNewRecord: boolean = false) { // Public Domain/MIT
        var d = new Date().getTime();//Timestamp
        var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
        var guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16;//random number between 0 and 16
            if (d > 0) {//Use timestamp until depleted
                r = (d + r) % 16 | 0;
                d = Math.floor(d / 16);
            } else {//Use microseconds since page-load if supported
                r = (d2 + r) % 16 | 0;
                d2 = Math.floor(d2 / 16);
            }
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });

        if (_isNewRecord) {
            var splitted = guid.split('-');
            splitted[0] = 'newrecrd';
            guid = splitted.join('-');
        }

        return guid;
    }

    static getNameSurnameSplit(_str: string | undefined) {
        if (!_str)
            return { name: '', surname: '' }

        var name = "";
        var surname = "";

        var splitted = _str.split(' ').map(x => x.trim()).filter(x => x != '');

        for (var i = 0; i < splitted.length; i++) {
            if (i == splitted.length - 1)
                surname = splitted[i]
            else
                name += splitted[i] + " ";
        }

        return { name: name.trim(), surname: surname.trim() }
    }

    static randomNumber() {
        var ret = Math.floor(100000 + Math.random() * 900000);
        return ret.toString()
    }

    static isStringArray(value: any): value is string[] {
        if (value instanceof Array) {
            for (const item of value) {
                if (typeof item !== 'string') {
                    return false
                }
            }
            return true
        }
        return false
    }

    static sort(_list: number[] | string[]) {
        _list = _list.sort(function (a: any, b: any) { return a - b; });


        return _list;
    }

    static sortListByProperty(_list: any, _property: string, _reverseAfter = false) {
        var ll = _list.sort((a: any, b: any) => (a[_property] > b[_property]) ? 1 : -1);

        if (_reverseAfter)
            ll = ll.reverse();
        return ll;
    }

    static yyyyMMddToObject(_date: string) {
        if (this.isEmpty(_date))
            return {
                year: '',
                month: '',
                day: ''
            };

        _date = _date.split('T')[0];

        return {
            year: _date.split('-')[0],
            month: _date.split('-')[1],
            day: _date.split('-')[2]
        };
    }

    static removeHtmlFromString(_str: string) {
        return _str.replace(/<\/?[^>]+(>|$)/g, "");
    }

    // static ddMMyyyyToDate(_str: string) {
    //     var obj = this.ddMMyyyyToObject(_str)
    //     var yyyyMMdd = obj.year + "-" + obj.month + "-" + obj.day + " 00:00:00";
    //     var returnVal = moment(yyyyMMdd, "YYYY-MM-DD HH:mm:ss").add(3, 'hours').toDate();
    //     return returnVal;
    // }

    static yyyyMMddToddMMyyyy(_str: string) {
        if (this.isEmpty(_str))
            return '';

        return this.yyyyMMddToObject(_str).day + "." + this.yyyyMMddToObject(_str).month + "." + this.yyyyMMddToObject(_str).year;
    }

    static ddMMyyyyToObject(_date: string) {
        return {
            year: _date.split('.')[2],
            month: _date.split('.')[1],
            day: _date.split('.')[0]
        };
    }

    static correctPrice = (_number: any, decimalPoint: number = 2) => {
        if (this.isEmpty(_number))
            return '';

        _number = Math.abs(parseFloat(_number.toString().replace(",", ".")));

        _number = _number.toLocaleString('tr-TR', {
            style: 'currency',
            currency: 'TRY',
            minimumFractionDigits: decimalPoint,
            maximumFractionDigits: decimalPoint,
        });

        return _number.replace('₺', "");
    }

    static dateParser(_date: string | undefined, _withTime: boolean = false) {
        if (this.isEmpty(_date))
            return '';

        if (!_date)
            return '';

        var result = "";
        var date = _date.includes('T') ? _date.split('T')[0] : _date.split(' ')[0];
        var year = date.split('-')[0];

        if (year == '0001')
            return '';

        var month = date.split('-')[1];
        var day = date.split('-')[2];

        result = `${day}.${month}.${year}`;

        if (_withTime) {
            var time = _date.includes('T') ? _date.split('T')[1] : _date.split(' ')[1];
            var hour = time.split(':')[0]
            var minute = time.split(':')[1]

            result += ` ${hour}:${minute}`
        }

        return result;
    }

    static parseErrorMessage(error: any) {
        console.log(JSON.stringify(error))

        console.log('error', JSON.stringify(error))

        console.log("error.response", error.response)

        if (typeof (error) === 'string') {
            return error;
        }

        if (!this.isEmpty(error.response) && !this.isEmpty(error.response.data) && typeof (error.response.data) == 'string') {
            return error.response.data;
        }

        // if (!this.isEmpty(error.response) && !this.isEmpty(error.response.data) /*&& typeof (error.response.data) == 'string'*/) {
        //     var errModel: ErrorModel = error.response.data;

        //     if (!Helpers.isEmpty(errModel.errors) && errModel.errors.length > 0)
        //         return errModel.errors.map(x => x.errorMessage.trim()).join(', ');
        // }

        if (!this.isEmpty(error.response) && !this.isEmpty(error.response.status) && (error.response.status == 401 || error.response.status == 403)) {
            return "Yetkisiz erişim.";
        }

        if (error.message === 'Network Error') {
            return "Bağlantı hatası, lütfen bağlantınızı kontrol ediniz."
        }

        return "Bir hata oluştu!";
    }

    static parseErrorMessageConnect(error: any) {
        console.log(JSON.stringify(error))

        console.log('error', JSON.stringify(error))

        console.log("error.response", error.response)

        if (typeof (error) === 'string') {
            return error;
        }

        // if (!this.isEmpty(error.response) && !this.isEmpty(error.response.data) /*&& typeof (error.response.data) == 'string'*/) {
        //     var errModel: ConnectErrorModel = error.response.data;

        //     if (!Helpers.isEmpty(errModel.errors) && errModel.errors.length > 0)
        //         return errModel.errors.map(x => x.trim()).join(', ');
        // }

        if (!this.isEmpty(error.response) && !this.isEmpty(error.response.status) && (error.response.status == 401 || error.response.status == 403)) {
            return "Yetkisiz erişim.";
        }

        if (error.message === 'Network Error') {
            return "Bağlantı hatası, lütfen bağlantınızı kontrol ediniz."
        }

        return "Bir hata oluştu!";
    }

    static dataParser(_resp: any) {
        if (_resp.status == 204)
            throw "Kayıt bulunamadı.";

        return _resp.data;
    }

    static getConstants() {
        return {
            client_id: 'AkgidaPortalUI',
            client_secret: '7sxQ54123!.19DSs23'
        }
    }

    static getWsEndpoint() {
        return this.getEndpoint().replace('https://', 'wss://').replace('http://', 'ws://');
    }

    static getEndpoint() {
        const env = process.env.REACT_APP_ENV;

        if (env == 'test')
            return "http://149.0.252.220:60000";
        else if (env == 'production')
            return "https://keylogxapi.ebbedev.com.tr";

        return "https://localhost:7048";
    }

    static getVersion() {
        return "v107";
    }

    static getPlaceholder() {
        return this.getEndpoint() + "/placeholder.png";
    }

    static get404() {
        return this.getEndpoint() + "/404.png";
    }

    static getStorageKeys() {
        return [
            "user",
            "user_token",
            "remembered_username",
            "remembered_password",
            "refresh_token",
            "username",
            "isCollapsed"
        ];
    }

    static sumOfNumbers(_numbers: number[]) {
        if (_numbers.length == 0)
            return 0;

        const sum = _numbers.reduce((partialSum, a) => partialSum + a, 0);
        return sum;
    }

    static nFormatter(num: number) {
        if (num >= 1000000000) {
            return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'G';
        }
        if (num >= 1000000) {
            return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
        }
        if (num >= 1000) {
            return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
        }
        return num.toFixed(1);
    }

    static prependZero(_str: string, _newLength: number) {
        while (_str.length < _newLength)
            _str = "0" + _str;

        return _str
    }

    static getMonthName(_month: number) {
        if (_month == 1) return 'Ocak';
        else if (_month == 2) return 'Şubat';
        else if (_month == 3) return 'Mart';
        else if (_month == 4) return 'Nisan';
        else if (_month == 5) return 'Mayıs';
        else if (_month == 6) return 'Haziran';
        else if (_month == 7) return 'Temmuz';
        else if (_month == 8) return 'Ağustos';
        else if (_month == 9) return 'Eylül';
        else if (_month == 10) return 'Ekim';
        else if (_month == 11) return 'Kasım';
        else if (_month == 12) return 'Aralık';
        else return "";
    }

    static getMonthList() {
        return [
            { label: 'Ocak', value: '1' },
            { label: 'Şubat', value: '2' },
            { label: 'Mart', value: '3' },
            { label: 'Nisan', value: '4' },
            { label: 'Mayıs', value: '5' },
            { label: 'Haziran', value: '6' },
            { label: 'Temmuz', value: '7' },
            { label: 'Ağustos', value: '8' },
            { label: 'Eylül', value: '9' },
            { label: 'Ekim', value: '10' },
            { label: 'Kasım', value: '11' },
            { label: 'Aralık', value: '12' }
        ]
    }

    static stringToBoolean(_val: string | undefined) {
        if (Helpers.isEmpty(_val))
            return undefined;

        return _val === 'true';
    }

    // static checkPermission(_name: string, auth: authSlice) {
    //     if ((_name == 'Fatura' || _name == 'Invoice') && !auth.user.user?.roles.map(x => x.code).includes('0001'))
    //         return false;

    //     if (_name == 'Limit' && !auth.user.user?.roles.map(x => x.code).includes('0002'))
    //         return false;

    //     return true;
    // }

    static parseFilterTopItem(_start: string, _end: string) {
        if (!this.isEmpty(_start) && !this.isEmpty(_end))
            return _start + " - " + _end;

        if (!this.isEmpty(_start))
            return _start;

        if (!this.isEmpty(_end))
            return _end;

        return "";
    }

    static generateNumberArray(_start: number, _end: number) {
        var arr: number[] = []

        for (var i = _start; i <= _end; i++) {
            arr.push(i);
        }

        return arr;
    }

    static prepareFileUrl(_fileName: string) {
        return this.getEndpoint() + '/' + (_fileName.endsWith('.pdf') ? "pdf" : "image") + "/" + _fileName;
    }

    static validateEmail(email: string) {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    static getGoBackUrl() {
        return '/' + window.location.href.split('listadd')[0].split('/').filter(x => x && x.trim() != '').pop() + '/list';
    }

    static getStatusText = (status: string) => {
        if (status == 'UNKNOWN')
            return "Veri Alınamıyor";

        if (status == 'IDLE')
            return "Rölanti";

        if (status == 'STOP')
            return "Kontak Açık";

        if (status == 'PASSIVE')
            return "Kontak Kapalı";

        if (status == 'ACTIVE')
            return "Hareket Halinde";

        return "";
    }
}